import React from "react";

// CountryFilterButtons:
export const CountryFilterButtons = ({
  filterCountriesData,
  filterOptions,
  handleUpdateCountry,
  isRedirecting,
}: any) => {
  return filterCountriesData
    .filter((country: any) => country?.country_url !== "study-in-india")
    .map((countryDetail: any) => {
      const isSelected =
        filterOptions?.country?.country_name === countryDetail?.country_name;
      return (
        <button
          key={countryDetail.id}
          onClick={() =>
            handleUpdateCountry(
              `/${countryDetail.country_url.replace(
                "study-in-",
                "colleges-in-"
              )}`
            )
          }
          disabled={isRedirecting}
          className={`px-4 py-0.5 text-[0.8rem] border border-gray-300 bg-gray-50 rounded-full transition-all whitespace-nowrap duration-200 ${
            isSelected
              ? "text-primary hover:text-blue-800 hover:bg-gray-100 font-bold"
              : " hover:border-primary hover:text-primary hover:bg-white"
          } ${
            isRedirecting
              ? "bg-gray-300 cursor-not-allowed"
              : "hover:bg-gray-100"
          }
                `}
        >
          {countryDetail.country_name}
        </button>
      );
    });
};

// StateFilterButtons:
export const StateFilterButtons = ({
  filteredStates,
  filterOptions,
  searchQuery,
  isRedirecting,
  handleStateSelect,
}: any) => {
  return filteredStates.length > 0 ? (
    filteredStates.map((stateDetails: any) => {
      const isSelected =
        filterOptions?.state?.state_url === stateDetails?.state_url;
      const lowerCaseStateName = stateDetails.state_name.toLowerCase();
      const lowerCaseQuery = searchQuery.toLowerCase();
      const startIndex = lowerCaseStateName.indexOf(lowerCaseQuery);

      return (
        <button
          key={stateDetails.id}
          disabled={isRedirecting}
          onClick={() => handleStateSelect(stateDetails?.state_url)}
          className={`px-4 py-0.5 text-[0.8rem] border border-gray-300 bg-gray-50 rounded-full transition-all whitespace-nowrap duration-200 ${
            isSelected
              ? " text-primary border-primary hover:text-blue-800 hover:bg-gray-100 font-bold"
              : " hover:border-primary hover:text-primary hover:bg-white"
          } ${
            isRedirecting
              ? "bg-gray-300 cursor-not-allowed"
              : "hover:bg-gray-100"
          }
                `}
        >
          {startIndex !== -1 ? (
            <>
              {stateDetails.state_name.substring(0, startIndex)}
              <span
                className={`${
                  searchQuery.length >= 3
                    ? "bg-yellow-300 text-black font-semibold"
                    : ""
                } `}
              >
                {stateDetails.state_name.substring(
                  startIndex,
                  startIndex + searchQuery.length
                )}
              </span>
              {stateDetails.state_name.substring(
                startIndex + searchQuery.length
              )}
            </>
          ) : (
            stateDetails.state_name
          )}
        </button>
      );
    })
  ) : (
    <p className="text-gray-500 text-center w-full">No results found</p>
  );
};

// CityFilterButtons:
export const CityFilterButtons = ({
  filteredCities,
  filterOptions,
  searchQuery,
  isRedirecting,
  handleCitySelect,
}: any) => {
  return filteredCities?.map((cityDetails: any) => {
    const isSelected = filterOptions.city?.city_url === cityDetails?.city_url;
    const lowerCaseStateName = cityDetails.city_name.toLowerCase();
    const lowerCaseQuery = searchQuery.toLowerCase();
    const startIndex = lowerCaseStateName.indexOf(lowerCaseQuery);

    return (
      <button
        key={cityDetails.id}
        disabled={isRedirecting}
        onClick={() => handleCitySelect(cityDetails?.city_url)}
        className={`px-4 py-0.5 text-[0.8rem] border border-gray-300 bg-gray-50 rounded-full transition-all whitespace-nowrap duration-200 ${
          isSelected
            ? "text-primary hover:text-blue-800 hover:bg-gray-100 font-bold"
            : " hover:border-primary hover:text-primary hover:bg-white"
        } ${
          isRedirecting ? "bg-gray-300 cursor-not-allowed" : "hover:bg-gray-100"
        }
              `}
      >
        {startIndex !== -1 ? (
          <>
            {cityDetails.city_name.substring(0, startIndex)}
            <span
              className={`${
                searchQuery.length >= 3
                  ? "bg-yellow-300 text-black font-semibold"
                  : ""
              } `}
            >
              {cityDetails.city_name.substring(
                startIndex,
                startIndex + searchQuery.length
              )}
            </span>
            {cityDetails.city_name.substring(startIndex + searchQuery.length)}
          </>
        ) : (
          cityDetails.city_name
        )}
      </button>
    );
  });
};

// StreamFilterButtons:
export const StreamFilterButtons = ({
  filteredStreams,
  filterOptions,
  filterAvailableStreams,
  isRedirecting,
  handleUpdateStream,
}: any) => {
  return filteredStreams.map((streamDetails: any) => {
    const isSelected =
      streamDetails?.stream_name === filterOptions.stream?.stream_name ||
      filterAvailableStreams?.some(
        (data: any) => data?.id === streamDetails.id
      );

    const locInfo =
      filterOptions?.country?.country_url !== "study-in-india"
        ? "abroad"
        : "india";
    const redirectUrl = `/${streamDetails?.stream_name
      ?.replaceAll(" ", "-")
      .toLowerCase()}-colleges-in-${locInfo}`;

    return (
      <button
        key={streamDetails.id}
        disabled={isRedirecting}
        onClick={() => handleUpdateStream(redirectUrl)}
        className={`px-4 py-0.5 text-[0.8rem] border border-gray-300 bg-gray-50 rounded-full transition-all whitespace-nowrap duration-200 ${
          isSelected
            ? "text-primary hover:text-blue-800 hover:bg-gray-100 font-bold"
            : " hover:border-primary hover:text-primary hover:bg-white"
        } ${
          isRedirecting ? "bg-gray-300 cursor-not-allowed" : "hover:bg-gray-100"
        }
              `}
      >
        {streamDetails.stream_name}
      </button>
    );
  });
};

// CourseFilterButtons:
export const CourseFilterButtons = ({
  filteredCourses,
  filterOptions,
  searchQuery,
  isRedirecting,
  handleUpdateCourse,
  locInfo,
}: any) => {
  return filteredCourses?.map((courseDetails: any) => {
    const isSelected =
      filterOptions?.course?.course_name === courseDetails?.course_name ||
      filterOptions?.course?.course_url === courseDetails?.course_url ||
      filterOptions?.course?.abbreviation === courseDetails?.abbreviation;
    const lowerCaseStateName = courseDetails.course_name.toLowerCase();
    const lowerCaseQuery = searchQuery.toLowerCase();
    const startIndex = lowerCaseStateName.indexOf(lowerCaseQuery);

    const redirectUrl = `${courseDetails?.course_url}-colleges-in-${locInfo}`;

    return (
      <button
        key={courseDetails.id}
        disabled={isRedirecting}
        onClick={() => handleUpdateCourse(redirectUrl)}
        className={`px-4 py-0.5 text-[0.8rem] border border-gray-300 bg-gray-50 rounded-full transition-all whitespace-nowrap duration-200 ${
          isSelected
            ? "text-primary hover:text-blue-800 hover:bg-gray-100 font-bold"
            : " hover:border-primary hover:text-primary hover:bg-white"
        } ${
          isRedirecting
            ? "bg-gray-50 text-black cursor-not-allowed"
            : "hover:bg-gray-100 text-black"
        }
                  `}
      >
        {startIndex !== -1 ? (
          <>
            {courseDetails.course_name.substring(0, startIndex)}
            <span
              className={`${
                searchQuery.length >= 3
                  ? "bg-yellow-300 text-black font-semibold"
                  : ""
              } `}
            >
              {courseDetails.course_name.substring(
                startIndex,
                startIndex + searchQuery.length
              )}
            </span>
            {courseDetails.course_name.substring(
              startIndex + searchQuery.length
            )}
          </>
        ) : (
          courseDetails.course_name
        )}
      </button>
    );
  });
};


